<template>
    <div class="text-center">
        <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
        >
            <template v-slot:activator="{ on }">
                <v-btn
                        color="blue-grey darken-4"
                        style="color:white!important;"
                        text
                        v-on="on"
                >
                    <v-icon>
                        mdi-dots-vertical
                    </v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-list>
                    <v-list-item>

                        <v-list-item-content>
                            <v-list-item-title>{{user.first_name}} {{user.last_name}}</v-list-item-title>
                            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                            <v-spacer></v-spacer>
                            <div>
                                {{ user.groups }}
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text to="/auth/logout" >
                        <span>Logout</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: "LoginWidget",
        props: {
            theme: String,
        },
        data: () => ({
            title: "Login Widget",
            fav: true,
            menu: false,
            message: false,
            hints: true,
        }),
        computed: {
            user: function (){
                return this.$store.getters.user;
            },
            buffer_user: function(){
                return this.$store.getters.buffer_user;
            },
            user_groups_names: function(){
                return this.$store.getters.user_groups_names;
            }
        },
    }
</script>
